import React from "react";
import { Button } from "semantic-ui-react";

const ButtonTab = ({ setTab, tab, TABS }) => {
  return (
    <Button.Group
      className={`custom-button !bg-transaction-card dark:!bg-base-light-dark rounded-[5px] ${
        TABS?.length === 1 && "!w-full"
      }`}
      widths={TABS?.length}
    >
      {TABS?.map((item) => (
        <Button
          key={item.label}
          onClick={() => {
            setTab(item.value);
          }}
          className={`${
            tab === item.value
              ? "!bg-[#4C555E] !text-light-white !rounded-[5px]"
              : "!bg-transaction-card dark:!bg-base-light-dark !text-light-text"
          } font-medium !py-[14px]`}
        >
          <span
            className={`${
              tab === item.value ? "!text-light-white " : "!text-light-text"
            } `}
          >
            {item.label}
          </span>
        </Button>
      ))}
    </Button.Group>
  );
};

export default ButtonTab;
